module.exports = __webpack_public_path__ + "static/1273860602.33a8b022.jpg";